import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

interface SmtpCampaignViews {
    id?: number
    smtp_gateway_id: number;
    name: string;
    subject: string;
    message: string;
    status: number;
    schedule_time: string | null;
    retries: number;
    xls_file: string;
    emails_count: number;
    email_to_be_processed: number;
    failed_reason: string | null;
    createdAt: string;
    updatedAt: string;
}

interface SmtpCampaignViewState {
    smtpcampaignviewsdata: SmtpCampaignViews[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}


// // ==================view-Smtpcampaign-api-start=============
export const GetSmtpCampaignView = createAsyncThunk<
    SmtpCampaignViews,
    number,
    { rejectValue: string }
>(
    'smtpcampaignviewsdata/GetSmtpCampaignView',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/api/admin/smtp-campaign/${id}`);
            return response.data.SMTPCampaign;
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);
// // ==================view-Smtpcampaign-api-end============

const initialState: SmtpCampaignViewState = {
    smtpcampaignviewsdata: [],
    info: null,
    error: null,
    loading: false,
};

const smtpcampaignSlice = createSlice({
    name: "Smtpcampaignview",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetSmtpCampaignView.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetSmtpCampaignView.fulfilled, (state, action: PayloadAction<SmtpCampaignViews>) => {
                state.loading = false;
                state.error = null;
                state.smtpcampaignviewsdata = [action.payload];
            })
            .addCase(GetSmtpCampaignView.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default smtpcampaignSlice.reducer;